export class Receiving {
  id: number;
  //supplier: string;
  supplier_id: string;
  supplier_name: string;
  supplier_code: string;
  receiving_number: string;
  qty: number;

  pieces: number;
  quantity: number;
  actual_length: number;
  requesting_branch_name: string;
  
  weight: number;
  actual_weight: number;
  status: string;
  supplier: string;
  po_id: string;
  po_number: string;
  order_date: string;
  estimated_arrival_date: string = (new Date()).toISOString().substr(0,10);
  actual_arrival_date: string = (new Date()).toISOString().substr(0,10);
  color: string;
  notes: string;
}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/receiving/receiving.ts